import React from 'react';
import skinsStyles from './styles/BlankScreen.scss';
import BaseScreenSkin, { BaseScreenSkinProps } from './BaseScreenSkin';

const BlankScreen: React.FC<Omit<BaseScreenSkinProps, 'skin' | 'skinStyles'>> =
  props => <BaseScreenSkin {...props} skinStyles={skinsStyles} />;

export default BlankScreen;
